// extracted by mini-css-extract-plugin
export default {"errorMsg":"jbBXsqX","opacityIn":"BfORgGv","link":"jcUMJo6"};